import { useMutation } from 'react-query';
import { sharedWorkflowService } from 'api/services';
import { useSiteDetection } from 'shared/hooks';
import { UseCreateWorkflowPayload } from './use-create-workflow.types';

export const useCreateWorkflow = () => {
  const { site } = useSiteDetection();

  const mutationFn = async (payload: UseCreateWorkflowPayload) => {
    return await sharedWorkflowService.createWorkflow(
      site,
      payload.workflowName,
      payload.graphData
    );
  };

  return useMutation({ mutationFn });
};
